/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaCellStatusResponse model module.
 * @module model/AqaCellStatusResponse
 * @version v0
 */
export default class AqaCellStatusResponse {
  /**
   * Constructs a new <code>AqaCellStatusResponse</code>.
   * @alias module:model/AqaCellStatusResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaCellStatusResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaCellStatusResponse} obj Optional instance to populate.
   * @return {module:model/AqaCellStatusResponse} The populated <code>AqaCellStatusResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaCellStatusResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('rowStatus'))
        obj.rowStatus = ApiClient.convertToType(data['rowStatus'], 'Number');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('rowStatuses'))
        obj.rowStatuses = ApiClient.convertToType(data['rowStatuses'], [AqaCellStatusResponse]);
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaCellStatusResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaCellStatusResponse.prototype.message = undefined;

/**
 * @member {Number} rowStatus
 */
AqaCellStatusResponse.prototype.rowStatus = undefined;

/**
 * @member {Number} position
 */
AqaCellStatusResponse.prototype.position = undefined;

/**
 * @member {Array.<module:model/AqaCellStatusResponse>} rowStatuses
 */
AqaCellStatusResponse.prototype.rowStatuses = undefined;

/**
 * @member {Boolean} successful
 */
AqaCellStatusResponse.prototype.successful = undefined;

